import { render, staticRenderFns } from "./SchlagFormular.vue?vue&type=template&id=a73b3e80"
import script from "./SchlagFormular.vue?vue&type=script&lang=js"
export * from "./SchlagFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports